<div class="profile-box">
  <!-- box header section -->
  <div class="profile-box__header">
    <!-- favorites title -->
    <div class="profile-box__tabs-container">
      <h1 class="profile-box__title">
        {{ 'profileMenu.favorites' | translate }}
      </h1>
      <!-- favorites tabs -->
      <pwj-section-tabs
        class="profile-box__tabs"
        [tabs]="tabsItems"
        [currentTab]="currentTab"
        translateKey="profile.favorites."
        (onSelectTab)="onTabChange($event)"></pwj-section-tabs>
    </div>
    <!-- remove all favorites btn -->
    @if (favoriteProductsCount > 0) {
      <div class="profile-box__actions">
        <pwj-button color="white" icon="trash" (click)="removeAllFavorites()">
          <span class="mt-2 text-2xl">
            {{ 'profile.favorites.deleteAll' | translate }}
          </span>
        </pwj-button>
      </div>
    }
  </div>

  <!-- page -->
  <router-outlet></router-outlet>
</div>
